import React from "react";
import GeneralLedgerAssign from "./GeneralLedgerAssign";
import dataJson from "./generel-ledger-assign.json";

export default function ReusableComponentTrial() {
    return <GeneralLedgerAssign data={dataJson} />;
}
